import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  addLocaleData,
  FormattedMessage,
  FormattedNumber,
  injectIntl,
  intlShape
} from 'react-intl';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';
import de from 'react-intl/locale-data/de';

import { get, cloneDeep, isEmpty } from 'lodash';
import { reduxForm } from 'redux-form';
import { GUEST_UPDATE_BOOKING_FORM } from './constants';

import Breadcrumb from '../../../elements-breadcrum/breadcrumb';
import ModalManager from '../../../elements-modal/modal-manager';
import { PaymentErrorModal } from '../../../app-bookings-custom/modals/payment-error-modal';
import BookingDetails from '../../guest/BookingDetails';
import AddOns from '../../guest/AddOns';
import {
  priceBreakdownObject,
  showFormError,
  normalizedContractsShape
} from '../../../app-bookings-request/forms/bookingUtil';
import submitGuestUpdateForm from './submit/submitGuestUpdateForm';
import validateGuestUpdateForm from './validate/validateGuestUpdateForm';
import ReviewUpdate from '../ReviewUpdate';
import StickyFooter from '../../../partials-footer/StickyFooter';
import Button from '../../../elements-buttons/Button';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import classNames from 'classnames';
import { BookingUpdateSummary } from '../../../elements-summaries/booking-update-summary/BookingUpdateSummary';

class UpdateBookingGuestMain extends Component {
  componentDidMount() {
    // add English, French and German locales
    addLocaleData([...en, ...fr, ...de]);
  }

  render() {
    const {
      currentStep,
      spaceRental,
      showSkeleton,
      pendingContracts,
      currentContracts,
      handleSubmit = null,
      showAddOns,
      handleBackClick = null,
      handleCancelClick = null,
      toggleModal = null,
      whichModal = null,
      paymentErrorMsg = '',
      isBrowseAddOns,
      handleBreadcrumbClick,
      alcoholConsumed,
      intl,
      profile
    } = this.props;

    const priceBreakdown = priceBreakdownObject(pendingContracts);
    const activityDetailBooking = cloneDeep(pendingContracts.bookingObject);
    if (!isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = 'GUEST';
      activityDetailBooking.attendees = activityDetailBooking.number_of_guests;
      activityDetailBooking.spaceRental = priceBreakdown.spaceRentalTotal;
      activityDetailBooking.listing =
        get(pendingContracts, 'bookingObject.listing') ||
        get(spaceRental, 'meta.listing', {});
    }

    const alcoholConsumption =
      'string' === typeof alcoholConsumed
        ? 'true' === alcoholConsumed
        : alcoholConsumed;

    const breadCrumbSteps = isBrowseAddOns
      ? [
          {
            step: 2,
            text: this.props.intl.formatMessage({
              id: 'inbox_guest_update_booking.update_booking_guest_main.addons',
              defaultMessage: 'Add-ons'
            })
          },
          {
            step: 3,
            text: this.props.intl.formatMessage({
              id: 'inbox_guest_update_booking.update_booking_guest_main.review',
              defaultMessage: 'Review'
            })
          }
        ]
      : [
          {
            step: 1,
            text: this.props.intl.formatMessage({
              id: 'inbox_guest_update_booking.update_booking_guest_main.booking_details',
              defaultMessage: 'Booking Details'
            })
          },
          ...(showAddOns
            ? [
                {
                  step: 2,
                  text: this.props.intl.formatMessage({
                    id: 'inbox_guest_update_booking.update_booking_guest_main.show_addons',
                    defaultMessage: 'Add-ons'
                  })
                },
                {
                  step: 3,
                  text: this.props.intl.formatMessage({
                    id: 'inbox_guest_update_booking.update_booking_guest_main.show_review',
                    defaultMessage: 'Review'
                  })
                }
              ]
            : [
                {
                  step: 2,
                  text: this.props.intl.formatMessage({
                    id: 'inbox_guest_update_booking.update_booking_guest_main.review_2',
                    defaultMessage: 'Review'
                  })
                }
              ])
        ];

    const pageDetailsWithAddOns = {
      1: {
        header: this.props.intl.formatMessage({
          id: 'inbox_guest_update_booking.update_booking_guest_main.booking_details_header',
          defaultMessage: 'Update booking details'
        }),
        component: (
          <BookingDetails
            formName={GUEST_UPDATE_BOOKING_FORM}
            {...this.props}
          />
        )
      },
      2: {
        header: this.props.intl.formatMessage({
          id: 'inbox_guest_update_booking.update_booking_guest_main.addons_header',
          defaultMessage: 'Add-ons'
        }),
        component: (
          <AddOns {...this.props} formName={GUEST_UPDATE_BOOKING_FORM} />
        )
      },
      3: {
        header: this.props.intl.formatMessage({
          id: 'inbox_guest_update_booking.update_booking_guest_main.review_header',
          defaultMessage: 'Review'
        }),
        component: (
          <ReviewUpdate
            {...this.props}
            priceBreakdown={priceBreakdown}
            handleBackClick={handleBackClick}
            activityDetailBooking={activityDetailBooking}
            alcoholConsumed={alcoholConsumption}
            guestView
          />
        )
      }
    };

    const pageDetailsNoAddOns = {
      1: {
        header: this.props.intl.formatMessage({
          id: 'inbox_guest_update_booking.update_booking_guest_main.booking_header',
          defaultMessage: 'Update booking details'
        }),
        component: (
          <BookingDetails
            formName={GUEST_UPDATE_BOOKING_FORM}
            {...this.props}
          />
        )
      },
      2: {
        header: this.props.intl.formatMessage({
          id: 'inbox_guest_update_booking.update_booking_guest_main.review_header_addons',
          defaultMessage: 'Review'
        }),
        component: (
          <ReviewUpdate
            {...this.props}
            priceBreakdown={priceBreakdown}
            handleBackClick={handleBackClick}
            activityDetailBooking={activityDetailBooking}
            alcoholConsumed={alcoholConsumption}
            guestView
          />
        )
      }
    };

    const pageDetails = showAddOns
      ? pageDetailsWithAddOns
      : pageDetailsNoAddOns;
    const reviewPage =
      ((showAddOns || isBrowseAddOns) && 3 === currentStep) ||
      (!showAddOns && 2 === currentStep);

    return (
      <SharedIntlProviderHOC>
        <form onSubmit={handleSubmit}>
          <div className='ps-container-lg-margin ps-container-fixed'>
            <ModalManager whichModal={whichModal} toggleModal={toggleModal}>
              <PaymentErrorModal
                ref='paymentErrorModal'
                errorMsg={paymentErrorMsg}
              />
            </ModalManager>
            <div className='ps-row'>
              <div className='col-xs-12 col-lg-7'>
                <Breadcrumb
                  currentStep={currentStep}
                  steps={[...breadCrumbSteps]}
                  onClick={handleBreadcrumbClick}
                />

                <div className='header'>
                  <h2 className='' data-testing-id='page-details-header'>
                    {pageDetails[currentStep].header}
                  </h2>
                </div>

                <div>{pageDetails[currentStep].component}</div>
              </div>

              <div
                className='col-xs-12 col-lg-5 margin-xl-top'
                style={{ marginBottom: '80px' }}
              >
                <BookingUpdateSummary
                  pendingContracts={pendingContracts}
                  currentContracts={currentContracts}
                  profile={profile}
                  intl={intl}
                  showSkeleton={showSkeleton}
                />
              </div>

              {!reviewPage && (
                <StickyFooter className='ps-container-lg-margin ps-container-fixed flex middle'>
                  <div className='ps-row flex-one'>
                    <div className='col-xs-12 flex space-between'>
                      {1 === currentStep ||
                      (isBrowseAddOns && 2 === currentStep) ? (
                        <Button
                          type='button'
                          className='btn btn-default classic'
                          attributes={{
                            'data-testing-id': 'booking-details-cancel-btn'
                          }}
                          onClick={handleCancelClick}
                        >
                          <FormattedMessage
                            id='inbox_guest_update_booking.update_booking_guest_main.cancel'
                            defaultMessage='Cancel'
                          />
                        </Button>
                      ) : (
                        <Button
                          type='button'
                          className='btn btn-default classic'
                          onClick={handleBackClick}
                          attributes={{
                            'data-testing-id': 'booking-details-back-btn'
                          }}
                        >
                          <FormattedMessage
                            id='inbox_guest_update_booking.update_booking_guest_main.back'
                            defaultMessage='Back'
                          />
                        </Button>
                      )}

                      <div className='flex middle'>
                        <div
                          className='heavy margin-lg-right visible-xs'
                          data-testing-id='guest-payment'
                        >
                          <FormattedNumber
                            value={priceBreakdown.guestPayment}
                            currency={priceBreakdown.currency}
                            style={'currency'}
                          />
                        </div>
                        <Button
                          type='submit'
                          attributes={{
                            'data-testing-id': 'booking-details-next-btn'
                          }}
                          category='primary'
                        >
                          <FormattedMessage
                            id='inbox_guest_update_booking.update_booking_guest_main.next'
                            defaultMessage='Next'
                          />
                        </Button>
                      </div>
                    </div>
                  </div>
                </StickyFooter>
              )}
            </div>
          </div>
        </form>
      </SharedIntlProviderHOC>
    );
  }
}

const config = {
  form: GUEST_UPDATE_BOOKING_FORM,
  onSubmit: submitGuestUpdateForm,
  validate: validateGuestUpdateForm,
  onSubmitFail: showFormError
};

UpdateBookingGuestMain.propTypes = {
  currentStep: PropTypes.number,
  spaceRental: PropTypes.object,
  showSkeleton: PropTypes.bool,
  initialValues: PropTypes.object,
  addOnsContracts: PropTypes.array,
  profile: PropTypes.object,
  handleSubmit: PropTypes.func,
  isBrowseAddOns: PropTypes.bool,
  showAddOns: PropTypes.bool,
  handleBackClick: PropTypes.func,
  handleCancelClick: PropTypes.func,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.string,
  paymentErrorMsg: PropTypes.func,
  handleBreadcrumbClick: PropTypes.func,
  intl: intlShape,
  currentContracts: normalizedContractsShape,
  pendingContracts: normalizedContractsShape
};

export default injectIntl(reduxForm(config)(UpdateBookingGuestMain));
